import RemoteCombo, { RemoteComboProps, configureSuggestStore } from "../../../components/form/RemoteCombo";
import { PeriodicService } from "../../../models/Types";

const cmd = 'PeriodicServiceList';
const valueField = 'Name';

export const periodicServiceStore = configureSuggestStore<PeriodicService>(cmd, valueField, 30 * 60, ['PeriodicServiceSave']);

export default function PeriodicServiceCombo({ ...props }: RemoteComboProps<PeriodicService>) {
    return <RemoteCombo<PeriodicService>
        store={periodicServiceStore}
        typeId="PeriodicService"
        {...props}    />;
}